import React from "react";
import ContactUsForm from "../../ContactPage/ContactUsForm";
import { DS } from "../../../utils/designSystem";

const ContactFormSection = () => {
  return (
    <div>
      <div className={DS.section.header}>
        <h2 className={DS.text.sectionTitle}>Get in Touch</h2>
        <div className={DS.section.underline} />
        <p className={`${DS.text.sectionSub} max-w-lg`}>
          Have a question, partnership idea, or just want to say hello? Fill
          out the form and we'll get back to you.
        </p>
      </div>
      <div className="mt-8 mx-auto max-w-2xl">
        <ContactUsForm />
      </div>
    </div>
  );
};

export default ContactFormSection;
